export enum WizardSteps {
  BasketOverview,
  BasketValidation,
  Payment,
  PaymentStatus,
  Extension
}
